import Vue from 'vue'
import VueMeta from 'vue-meta'
import Quasar from 'quasar'

Vue.use(VueMeta)

Vue.use(Quasar, {
  config: {
    loadingBar: {
      skipHijack: true,
      color: 'pink',
      size: '3px',
      position: 'top'
    }
  },
})
